export default "__VITE_ASSET__r5n9VE8i__"